import { ActionsDropdown } from 'components/Buttons/ActionsDropdown'
import { ComposeMode } from './ComposePanel'
import {
  EmailDealActionCallbacks,
  buildActionContext,
  useEmailThreadActions,
} from './emailActions'

interface ThreadMessageMenuProps extends EmailDealActionCallbacks {
  onCompose?: (mode: ComposeMode) => void
  assignDealSubContent?: React.ReactNode
  isHidden?: boolean
  isOwnThread?: boolean
}

/** Per-message 3-dot actions menu. */
export function ThreadMessageMenu({
  onCompose,
  assignDealSubContent,
  isHidden,
  isOwnThread,
  ...dealCallbacks
}: ThreadMessageMenuProps) {
  const actions = useEmailThreadActions(
    buildActionContext(
      dealCallbacks,
      onCompose,
      assignDealSubContent,
      isHidden,
      isOwnThread
    )
  )
  return <ActionsDropdown actions={actions} />
}
